<ng-container *transloco="let t;">
<div class="signing-page-wrapper" *ngIf="viewDocument">
    <span class="signing-sidebar-openIcon" (click)="toggleSidebar('signing-right-sidebar')" *ngIf="!['pdfview','verification'].includes(isPdfView)">
        <i data-feather="list" [size]="22"></i>
    </span>

    <div class="template-main-container" *ngIf="!['verification'].includes(isPdfView)" [ngStyle]="{'visibility' : !loadingSigningArea ? '' : 'hidden'}">
        <div class="template-page" [innerHTML]="templateContent"></div>
    </div>

    @if (!loadingSigningArea && [signingStatusEnum.SIGNED, signingStatusEnum.COMPLETED].includes(roleDetail.roleable.status) && roleDetail.roleable.status_updated_manually === 0) {
        <!-- Verification Page Html Start -->
        <div class="verification-page-container">
            <app-verification-page [roleId]="roleId" [document_id]="roleDetail?.roleable.id" [is_sender]="is_sender" [roleDetail]="roleDetail"></app-verification-page>
        </div>
        <!-- / Verification Page Html End -->
    }

    @if (!['pdfview','verification'].includes(isPdfView))
    {
        @if (!loadingSigningArea && [signingStatusEnum.SENT, signingStatusEnum.DELIVERED, signingStatusEnum.VIEWED, signingStatusEnum.FAILED].includes(roleDetail.recipient_role_detail.status)) {
            @if (roleDetail.authentication_type == authenticationTypeEnum.BANKID) {
                <div class="bankId-box-wrapper">
                    <app-sign-bank-id-box [roleDetail]="roleDetail"></app-sign-bank-id-box>
                </div>
            }
            @else if ([authenticationTypeEnum.NORWEGIANBANKID, authenticationTypeEnum.DANISHMITID, authenticationTypeEnum.FINNISHBANKID].includes(roleDetail.authentication_type)){
                <div class="norwegian-bankID-box">
                    <app-norwegian-bank-id-box [roleDetail]="roleDetail"></app-norwegian-bank-id-box>
                </div>
            }@else if ([authenticationTypeEnum.ESIGNATURE, authenticationTypeEnum.ESIGNANDSMSPIN].includes(roleDetail.authentication_type) && !assignedSignatureBox && roleDetail?.company?.finger_sign === 1) {
                <div class="signature-box-wrapper">
                    <app-signature-box [roleDetail]="roleDetail"></app-signature-box>
                </div>
            }
            @if (!loadingSigningArea && [authenticationTypeEnum.ESIGNATURE, authenticationTypeEnum.ESIGNANDSMSPIN, authenticationTypeEnum.ATTEST].includes(roleDetail.authentication_type)){
                <div class="signing-buttons-wrapper">
                    <div class="container">
                        <div class="row justify-content-center">
                            @switch (roleDetail.authentication_type) { 
                                @case (authenticationTypeEnum.ESIGNATURE) {
                                    <ng-template [ngTemplateOutlet]="signatureMethod"></ng-template>
                                }
                                @case (authenticationTypeEnum.ATTEST) {
                                    <ng-template [ngTemplateOutlet]="attestMethod"></ng-template>
                                }
                                @case (authenticationTypeEnum.ESIGNANDSMSPIN) {
                                    <ng-template [ngTemplateOutlet]="esignandsmspinMethod"></ng-template>
                                }
                            }
                            <ng-template #signatureMethod>
                                <div class="col-md-6 col-lg-6 col-sm-12 signing-left-btn">
                                    <button type="button" class="btn btn-success signing-info-btn" (click)="agree()">
                                        <span class="signingInfoBtnCheck">
                                        <div class="custom-control custom-checkbox">
                                            <input [value]="iAgreed" type="checkbox" class="custom-control-input" id="customCheck1" [checked]="iAgreed" (change)="agree()" />
                                            <label class="custom-control-label" for="customCheck1"></label>
                                        </div>
                                        </span>
                                        <span class="signingInfoText">{{t("Confirm button text for signing process (Signing page - section) - I certify that I have read and understood the content in this document and certify that I have the power to continue")}}</span>
                                    </button>
                                </div>
                                <div class="col-md-6 col-lg-6 col-sm-12 signing-right-btn">
                                    <button [disabled]="!iAgreed" type="button" class="btn btn-success signing-process-btn" (click)="validateTheSigningProgress()">{{t("Sign document button text (Signing page - section) - Sign")}}</button>
                                </div>
                            </ng-template>
                            <ng-template #attestMethod>
                                <div class="col-md-6 col-lg-6 col-sm-12 signing-right-btn">
                                    <button [disabled]="attestLoading" type="button" class="btn btn-success signing-process-btn" (click)="attestTheDocument()"><span *ngIf="attestLoading" class="spinner-border spinner-border-sm ms-50"></span> {{t("Attest document button text (Signing page - section) - Attest")}}</button>
                                </div>
                            </ng-template>
                            <ng-template #esignandsmspinMethod>
                               <app-esign-and-sms-pin class="esign-and-sms-pin-component" [roleDetail]="roleDetail" (signDocument)="validateTheSigningProgress()"></app-esign-and-sms-pin>
                            </ng-template>
                        </div>
                    </div>
                </div>
            }
        }
    }

    <core-sidebar *ngIf="!['pdfview','verification'].includes(isPdfView)" class="modal modal-slide-in sidebar-todo-modal fade signing-right-sidebar show" name="signing-right-sidebar">
        <div class="slideout-content">
            <div class="modalsd modal-slide-in sdfade" id="modals-slide-in">
                <div class="modal-dialog">
                    <form class="add-new-user modal-content pt-0">
                        <div class="modal-header mb-1 d-flex justify-content-between align-items-center px-2 py-1">
                            <div class="d-flex justify-content-end align-items-center text-dark cursor-pointer">
                                <!-- <span placement="auto" container="body" ngbTooltip="Close" (click)="toggleSidebar('signing-right-sidebar')">
                                    <i data-feather="x" [size]="16" data-dismiss="modal" aria-label="Close"></i>
                                </span> -->
                            </div>
                        </div>
                        <div class="modal-body flex-grow-1 p-0">
                            <div class="signing-sidebar-wrapper">
                                @if (!loadingSigningArea) {
                                    <app-signing-sidebar [roleDetail]="roleDetail" [roleId]="roleId" [document_id]="roleDetail?.roleable.id" [is_sender]="is_sender"></app-signing-sidebar>       
                                }
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </core-sidebar>
</div>

<!-- Add Signature Signing Modal Modal Sart -->
<ng-template #addSignatureSigningModal let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="myModalLabel1">{{t("Modal header title add Signature (Signing page - section) - Add Signature")}}</h4>
        <button type="button" class="close" (click)="closeModal('close')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body p-0" tabindex="0" ngbAutofocus>
        <app-signature-box></app-signature-box>
    </div>
    <div class="modal-footer">
        <button [disabled]="activeImage === -1" type="button" class="btn btn-primary" (click)="closeModal('close')" rippleEffect>
            {{t("Add button title (add button) - Add")}}
        </button>
    </div>
</ng-template>
<!-- / Add Signature Signing Modal Modal End -->

<!-- Sign Document Modal Modal Sart -->
<ng-template #modalSignDocument let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="myModalLabel1">{{t("Modal header title Sign Document (Signing page - section) - Signature")}}</h4>
        <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" tabindex="0" ngbAutofocus>
        <p class="sign-doc-infoText m-0">{{ t("Confirm modal body text for sign document (Signing page - section) - By clicking Sign document I recipient am signing the document document and agree to be legally bound by this digital signature just the same as a pen and paper signature or by using initials", {
            recipient : roleDetail.recipient.firstname + (roleDetail.recipient?.lastname ?? ''),
            document : roleDetail?.roleable?.visible_name ?? roleDetail?.roleable?.name
        }) }}.</p>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" (click)="modal.close(false)" rippleEffect>
            {{ t("Cancel button text (cancel button) - cancel") }}
        </button>
        <button type="button" class="btn btn-primary" rippleEffect (click)="signDocument()">
            {{ t("Sign document button text (Signing page - section) - Sign Document") }} <span *ngIf="signingLoader" class="spinner-border spinner-border-sm me-1"></span>
        </button>
    </div>
</ng-template>
<!-- / Sign Document Modal Modal End -->

<!-- After Sign Document Modal Modal Sart -->
<ng-template #modalAfterSignDocument let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="myModalLabel1"> Document signing </h4>
        <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    
    <div class="modal-body" tabindex="0" ngbAutofocus>
        <div class="signing-box-flow" *ngIf="signingDocFlowOne">
            <div class="fow-box-list">
                <div class="flow-box-icon">
                    <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
                        <circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none" />
                        <path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
                    </svg>                    
                </div>
                <div class="flow-box-info">
                    <h4 class="flow-box-infoTitle">You have signed</h4>
                    <p class="flow-box-infoText">Waiting for a signature from <strong>Fredrika Pontén</strong> Once all parties have signed the document, you will receive a link to the signed version sent to you.</p>
                </div>
            </div>

            <div class="fow-box-list">
                <div class="flow-box-icon">
                    <img src="../../assets/images/icons/DocumentIcon.svg">
                </div>
                <div class="flow-box-info">
                    <h4 class="flow-box-infoTitle"> Do you want to create your own flexible, digital agreements?</h4>
                    <p class="flow-box-infoText">Create a free Oneflow account and be on your way to the deals of the future!</p>
                </div>
            </div>
        </div>

        <div *ngIf="signingDocFlowTwo">
            <div class="signing-box-flow">
                <div class="fow-box-list align-items-start">
                    <div class="flow-box-icon">
                        <img src="../../assets/images/icons/DocumentIconChecked.svg">
                    </div>
                    <div class="flow-box-info">
                        <h4 class="flow-box-infoTitle">Do you want to create your own flexible, digital agreements?</h4>
                        <p class="flow-box-infoText">Create a free Oneflow account and be on your way to the deals of the future! <br> Your account will be created under the name <strong>Christian Nicolaisen</strong> at <strong> SimpleSign International AB</strong></p>

                        <div class="row mt-2">
                            <div class="col-12 col-lg-6 col-md-6">
                                <div class="form-group">
                                    <label class="col-form-label pt-0" for="">Email</label>
                                    <input type="text" class="form-control" id="email" />
                                </div>
                            </div>
                            
                            <div class="col-12 col-lg-6 col-md-6">
                                <div class="form-group">
                                    <label class="col-form-label pt-0" for="">Create password</label>
                                    <input type="text" class="form-control" id="cp" />
                                </div>
                            </div>
                            
                            <div class="col-12 col-lg-12 col-md-12">                              
                                <div class="custom-control custom-checkbox">
                                    <input type="checkbox" class="custom-control-input" id="customCheck1" />
                                    <label class="custom-control-label" for="customCheck1">I agree to SimpleSign Terms of Service</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="modal-footer" *ngIf="signingDocFlowOne">
        <button type="button" class="btn btn-outline-secondary" (click)="modal.close('Accept click')" rippleEffect>
            No thanks
        </button>
        <button type="button" class="btn btn-primary" (click)="signingDocumentFlow()" rippleEffect>
            Create a free account
        </button>
    </div>

    <div class="modal-footer" *ngIf="signingDocFlowTwo">
        <button type="button" class="btn btn-outline-secondary" (click)="modal.close('Accept click')" rippleEffect>
            Cancel
        </button>
        <button type="button" class="btn btn-primary" (click)="modal.close('Accept click')" rippleEffect>
            Create
        </button>
    </div>
</ng-template>
<!-- / After Sign Document Modal Modal End -->
</ng-container>